<template>
  <div>
    <div class="main-wrapper">
      <layout-header @changedLanguage="changedLanguage"></layout-header>
      <layout-navbar></layout-navbar>
      <!-- Page Wrapper -->
      <div class="page-wrapper">

        <!-- Page Content -->
        <div class="content container-fluid">

          <div class="crms-title row bg-white">
            <div class="col  p-0">
              <h3 class="page-title m-0">
                        <span class="page-title-icon bg-gradient-primary text-white mr-2">
                          <i class="feather-grid"></i>
                        </span> {{ $t('menu.shared_responsibility') }} </h3>
            </div>
            <div class="col p-0 text-right">
              <ul class="breadcrumb bg-white float-right m-0 pl-0 pr-0">
                <li class="breadcrumb-item"><router-link to="/index">DSMS</router-link></li>
                <li class="breadcrumb-item active">{{ $t('menu.shared_responsibility') }}</li>
              </ul>
            </div>
          </div>

          <!-- Page Header -->
          <div class="page-header pt-3 mb-0 ">
            <div class="row">
              <div class="col-12 text-right">
                <ul class="list-inline-item pl-0">
                  <li class="list-inline-item">
                    <DisplayColumnsComponent :table="table" :columns="columns" v-if="table"></DisplayColumnsComponent>
                  </li>
                  <li class="list-inline-item">
                    <button class="add btn btn-gradient-primary font-weight-bold text-white todo-list-add-btn btn-rounded" id="add_system" @click.prevent="showSharedResponsibility(null)">{{ $t('new_entry') }}</button>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <!-- /Page Header -->

          <!-- Content Starts -->
          <DataTableDSMS
            ref="dataTableDSMS"
            title="SharedResponsibility"
            fileName="SharedResponsibility"
            modelName="sharedresponsibility"
            deleteURL="todos/v1/delete_shared_responsibility/"
            editorPatchURL="/todos/v1/patch_shared_responsibility/"
            :columns="columns"
            :objects="sharedResponsibilityList"
            :exportColumns="[0, 1]"
            :editorCallback="true"
            @tableCreated="setTable"
            @editorCreated="setEditor"
            @showObject="showSharedResponsibility"
            @editorUpdated="setSharedResponsibility"
            v-if="sharedResponsibilityList.length > 0"
          ></DataTableDSMS>

          <FingerPrintSpinner v-show="sharedResponsibilityList.length <= 0" color="#9b3136" :size="300" :container-padding="100" />
          <!-- /Content End -->

        </div>
        <!-- /Page Content -->

      </div>
      <!-- /Page Wrapper -->
    </div>
    <SharedResponsibility :currentSharedResponsibility="currentSharedResponsibility" :vtselbst-name-list="sharedResponsibilityList" @sharedResponsibilityUpdated="setSharedResponsibility">
      <template v-slot:fileUpload><fileUpload :commentObject="currentSharedResponsibility" modelName="sharedresponsibility" @attachmentUpdated="setSharedResponsibility" modelVerboseName="SharedResponsibility"></fileUpload></template>
      <template v-slot:comments><comments :commentObject="currentSharedResponsibility" modelName="sharedresponsibility" @commentUpdated="setSharedResponsibility" modelVerboseName="SharedResponsibility"></comments></template>
    </SharedResponsibility>

  </div>
</template>
<script>
  import service from '@/utils/request.js';
  import {mapGetters, mapMutations, mapState} from 'vuex';

  import datePicker from 'vue-bootstrap-datetimepicker';
  import { Uploader, Button } from 'vant';
  import DisplayColumnsComponent from "@/components/component/DisplayColumnsComponent.vue";
  import DataTableDSMS from "@/components/component/DataTableDSMS.vue";
  import comments from "@/components/component/CommentComponent.vue";
  import fileUpload from "@/components/component/FileUploadComponent.vue";
  import SharedResponsibility from "@/components/component/SharedResponsibilityComponent.vue";
  import {newSharedResponsibility, objectModalName} from "@/utils/enums";
  import {deepCopy, updateDataTypes} from "@/utils";
  import store from "@/store";
  import FingerPrintSpinner from "@/components/component/FingerPrintSpinner.vue";
  export default {
    components: {
      FingerPrintSpinner,
      SharedResponsibility,
      fileUpload,
      comments,
      DataTableDSMS, DisplayColumnsComponent, 'van-uploader': Uploader, 'van-button': Button, datePicker},
    data() {
      return {
        datetimeOptions: {
          format: 'YYYY-MM-DD',
          useCurrent: false,
        },
        sharedResponsibilityList: [],
        currentSharedResponsibility: newSharedResponsibility,
        table: null,
        editor: null,
      }
    },
    created() {
      this.getSharedResponsibility()
    },
    computed: {
      ...mapState({accountid: state => state.account.accountid, }),
      ...mapGetters(['selectDataTypeOptions']),
      vtselbstNameList() {
        return this.vtseblstList.map(item => item.name)
      },
      columns() {
        return [
        {
          label: 'Nr.#',
          name: 'sequence',
          enableEditor: false,
          definition: {data: "sequence", width: '50px', className: 'dkl-vt-sequence reorder'},
        },
        {
          label: this.$t('name'),
          name: '',
          enableEditor: false,
          definition: {data: null, render: (data, type, row) => `Gemeinsame Verantwortung mit ${row.processor}`},
        },
        {
          label: this.$t('data_type'),
          name: 'data_type',
          type: 'select2',
          opts: {
            multiple: true,
            closeOnSelect: false,
            tags: true,
          },
          options: this.selectDataTypeOptions,
          enableEditor: true,
          definition: { data: "data_type", render: (data) => data.join(',') },
        },
        {
          label: this.$t('processor'),
          name: 'processor',
          type: 'text',
          enableEditor: true,
          definition: { data: "processor" },
        },
        {
          label: this.$t('how'),
          name: 'how',
          type: 'textarea',
          className: 'dkl-font-13',
          attr: {
            rows: 8
          },
          enableEditor: true,
          definition: { data: "how" },
        },
        {
          label: this.$t('legal_basis.name'),
          name: 'legal_base',
          type: 'textarea',
          className: 'dkl-font-13',
          attr: {
            rows: 8
          },
          enableEditor: true,
          definition: { data: "legal_base" },
        },
        {
          label: this.$t('storage_place'),
          name: 'storage_place',
          type: 'text',
          enableEditor: true,
          definition: { data: "storage_place" },
        },
        {
          label: this.$t('informer'),
          name: 'informer',
          type: 'text',
          enableEditor: true,
          definition: { data: "informer" },
        },
        {
          label: this.$t('deleter'),
          name: 'deleter',
          type: 'text',
          enableEditor: false,
          definition: { data: "deleter" },
        },
        {
          label: this.$t('responser'),
          name: 'responser',
          type: 'text',
          enableEditor: false,
          definition: { data: "responser" },
        },
        {
          label: this.$t('remarks'),
          name: 'remarks',
          type: 'textarea',
          className: 'dkl-font-13',
          attr: {
            rows: 8
          },
          enableEditor: true,
          definition: { data: "remarks" },
        },
      ]},
    },
    mounted() {},
    updated () {},
    methods: {
      ...mapMutations({setEdit: 'SET_EDIT'}),
      async changedLanguage() {
        this.$nextTick(async () => {
          if (this.table) this.table.destroy();
          await this.$refs.dataTableDSMS.initTable();
        });
      },
      setTable(table) {
        this.table = table
      },
      setEditor(editor) {
        this.editor = editor
        if (this.editor != null) this.editor.field('data_type').update(this.selectDataTypeOptions)
      },
      async setSharedResponsibility(respObject) {
        updateDataTypes(respObject.data_type, this.editor)
        const respIndex = this.sharedResponsibilityList.findIndex(item => item.id === respObject.id)
        if (respIndex === -1) {
          this.sharedResponsibilityList = this.sharedResponsibilityList.map(item => {
            item.sequence = item.sequence + 1
            return item
          })
          this.sharedResponsibilityList.push(respObject)
        } else {
          this.sharedResponsibilityList[respIndex] = respObject
        }
        this.table.clear().rows.add(this.sharedResponsibilityList).draw(false)
      },
      async getSharedResponsibility() {
        const that = this
        service.request({
          url: `todos/v1/shared_responsibility/${this.accountid}/`,
          method: 'GET',
          responseType: 'json'
        }).then(function(response) {
          that.sharedResponsibilityList = response.data;
        }).catch(function(err) {
          console.log(err)
        })
      },
      showSharedResponsibility(respID) {
        if (respID != null) {
          this.currentSharedResponsibility = this.sharedResponsibilityList.filter(item => item.id === respID)[0]
        } else {
          this.currentSharedResponsibility = deepCopy(newSharedResponsibility)
        }
        $('#' + objectModalName.sharedResponsibility).modal('show')
      }
    }
  }
</script>
